<script setup lang="ts"></script>

<template>
  <header class="nxg-retail-ssbt-header">
    <div class="nxg-retail-ssbt-header__leading">
      <slot name="leading" />
    </div>
    <div class="nxg-retail-ssbt-header__trailing">
      <slot name="trailing" />
    </div>
  </header>
</template>

<style scoped lang="scss">
.nxg-retail-ssbt-header {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--nxg-retail-ssbt-header-height, var(--st-app-bar-height, 4rem));
  padding: var(--nxgds-alias-spacing-none) var(--nxgds-alias-spacing-xs)
    var(--nxgds-alias-spacing-none) var(--nxgds-alias-spacing-lg);
  gap: var(--nxgds-alias-spacing-lg);
  background: var(--nxgds-mapped-color-surface-brand);

  &__leading {
    display: flex;
    flex: 1 0 0;
    min-width: 0;
  }

  &__trailing {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    gap: var(--nxgds-alias-spacing-xs);
  }
}
</style>
